import ContextMenu from '@/components/common/ContextMenu';
import CopyButton from '@/components/common/CopyButton';
import { WalletsResponse } from '@/types/sso';
import useContextMenu from '@/utils/hooks/useContextMenu';
import useLanguage from '@/utils/hooks/useLanguage';
import QRCode from 'qrcode';
import { Fragment, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { MdOutlineQrCodeScanner } from 'react-icons/md';

export interface SSIProfileWalletDetailsProps {
    ssiProfiles?: WalletsResponse[];
}

const SSIProfileWalletDetails = (props: SSIProfileWalletDetailsProps) => {
    const { ssiProfiles } = props;
    const [qrUrl, setQrUrl] = useState('');

    const lang = useLanguage();
    const contextMenu = useContextMenu();
    const { contextMenuX, contextMenuY, contextMenuVisible, handleOpenContextMenu, handleCloseContextMenu } =
        contextMenu;

    return (
        <Fragment>
            {ssiProfiles ? (
                <div className="text-xs text-brand-primary-light flex flex-col gap-5 p-3 bg-brand-background-dark border border-brand-neutral-700 rounded-md">
                    <div>{lang.portal.standardSettlementInstructions}:</div>
                    <div className="flex flex-col gap-2 text-xs text-brand-text mb-2 md:mb-4">
                        <div className="text-brand-neutral-400 grid grid-cols-4 gap-2">
                            <div>{lang.portal.network}</div>
                            <div className="col-span-3">{lang.portal.walletAddress}</div>
                        </div>
                        {ssiProfiles.map((profile) => {
                            return (
                                <div key={profile.walletId} className="grid grid-cols-4 gap-2">
                                    <div>{profile.networkName}</div>
                                    <div className="flex items-start gap-2 col-span-3 relative">
                                        <CopyButton value={profile.walletAddress}>
                                            {({ copied, copy }) => (
                                                <div
                                                    className="group cursor-pointer hover:text-brand-primary-light break-all"
                                                    onClick={copy}>
                                                    {profile.walletAddress}
                                                    {copied && (
                                                        <span className="text-2xs pointer-events-none absolute top-6 left-0 flex items-center p-1 px-2 rounded-sm bg-brand-neutral-700 text-brand-text z-10">
                                                            {lang.common.copied}
                                                        </span>
                                                    )}
                                                </div>
                                            )}
                                        </CopyButton>
                                        <div
                                            className="cursor-pointer hover:text-brand-primary-light w-4 h-4"
                                            onClick={(e) => {
                                                QRCode.toDataURL(profile.walletAddress, { width: 300 })
                                                    .then((url) => setQrUrl(url))
                                                    .catch((err) => console.error(err));
                                                handleOpenContextMenu(e);
                                            }}>
                                            <MdOutlineQrCodeScanner className="w-4 h-4" />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="flex flex-col gap-2">
                        <span className="text-xs text-brand-neutral-400">
                            {isMobile
                                ? lang.portal.tappingOnTheWalletAddressWillCopyItToYourClipboard
                                : lang.portal.clickingOnTheWalletAddressWillCopyItToYourClipboard}
                        </span>
                        <div className="text-xs text-brand-primary-light">
                            {lang.portal.pleaseTransferFundsONLYFromWhitelistedWalletAddresses}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-xs text-brand-primary-light flex flex-col gap-3 p-3 bg-brand-background-dark rounded-md">
                    <div>{lang.portal.standardSettlementInstructions}:</div>
                    <div className="text-xs text-brand-text">
                        {lang.portal.pleaseContactSupportToSetUpYourDepositRequest}
                    </div>
                </div>
            )}
            <ContextMenu
                x={contextMenuX}
                y={contextMenuY}
                offset={{ x: 16, y: 16 }}
                visible={contextMenuVisible}
                onClose={handleCloseContextMenu}
                className="!bg-brand-background !w-auto !z-[100]">
                {qrUrl && (
                    <div className="p-2">
                        <img src={qrUrl} alt="QR Code" className="w-48 h-48" />
                    </div>
                )}
            </ContextMenu>
        </Fragment>
    );
};

export default SSIProfileWalletDetails;
